import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import i18next from 'i18next';
import { updateDeliveryAreas } from '../../../actions';

import './Delivery.scss';

import API from '../../../actions/api';
import DeliveryMap from './DeliveryMap';
import DeliveryNavigator from './DeliveryNavigator';

class Delivery extends Component {
    state = {
        areasStatus: {},
        draftDeliveryAreas: [],
        generatedDeliveryAreas: []
    };

    constructor(props) {
        super(props);

        this.addNewDeliveryAreas = this.addNewDeliveryAreas.bind(this);
        this.removeDeliveryArea = this.removeDeliveryArea.bind(this);

        this.editDeliveryArea = this.editDeliveryArea.bind(this);
        this.updateDeliveryAreaEdit = this.updateDeliveryAreaEdit.bind(this);
        this.saveDeliveryAreaEdit = this.saveDeliveryAreaEdit.bind(this);
        this.cancelDeliveryAreaEdit = this.cancelDeliveryAreaEdit.bind(this);

        this.addNewDraftDeliveryArea = this.addNewDraftDeliveryArea.bind(this);
        this.removeDraftDeliveryArea = this.removeDraftDeliveryArea.bind(this);
        this.numberOfDraftedDeliveryAreas = this.numberOfDraftedDeliveryAreas.bind(this);

        this.drawDeliveryZonesOnMap = this.drawDeliveryZonesOnMap.bind(this);
        this.clearDrawnDeliveryZonesFromMap = this.clearDrawnDeliveryZonesFromMap.bind(this);
    }

    getDeliveryAreaPolygonBoundaries(polygon) {
        const path = polygon.getPath();
        console.log(path);
        let result;

        Object.keys(path).forEach(key => {
            if (!result) {
                try {
                    result = path[key].map(boundary => {
                        return { lat: boundary.lat(), lng: boundary.lng() };
                    });
                } catch (error) {
                    // 
                }
            }
        });

        return result;
    }

    addNewDraftDeliveryArea(polygon) {
        this.setState({
            draftDeliveryAreas: [...this.state.draftDeliveryAreas, polygon]
        });
    }

    removeDraftDeliveryArea(polygon) {
        const indexOfPolygonToRemove = this.state.draftDeliveryAreas.indexOf(polygon);
        const newPolygonsArray = [...this.state.draftDeliveryAreas];
        newPolygonsArray.splice(indexOfPolygonToRemove, 1);

        this.setState({ draftDeliveryAreas: newPolygonsArray });
    }

    addNewDeliveryAreas({ tag, estimatedTime, orderFee, minimumOrderPrice, companyMinimumOrderPrice }, deliveryZones, addToPool) {
        if (!deliveryZones) {
            deliveryZones = this.state.draftDeliveryAreas.map(polygon => {
                polygon.setMap(null);
                return { boundaries: this.getDeliveryAreaPolygonBoundaries(polygon) };
            });
            this.setState({ draftDeliveryAreas: [] });
        }
        if (addToPool) {
            API.deliveryAreasPool.add({ tag, zones: deliveryZones }).catch(err => {
                console.error('An error ocurred while trying to add area to pool. Details: ', err);
            });
        }

        const currentDeliveryAreas = this.props.restaurant.deliveryAreas || [];
        const updatedDeliveryArea = {
            tag,
            estimatedTime: parseFloat(estimatedTime),
            orderFee: parseFloat(orderFee),
            minimumOrderPrice: parseFloat(minimumOrderPrice),
            zones: deliveryZones
        };
        if (companyMinimumOrderPrice) updatedDeliveryArea.companyMinimumOrderPrice = parseFloat(companyMinimumOrderPrice);

        this.props.updateDeliveryAreas(this.props.restaurant.id, [...currentDeliveryAreas, updatedDeliveryArea]);
    }

    removeDeliveryArea(tag) {
        const indexOfDeliveryAreaToRemove = this.props.restaurant.deliveryAreas.findIndex(area => area.tag === tag);
        const newDeliveryAreas = [...this.props.restaurant.deliveryAreas];
        newDeliveryAreas.splice(indexOfDeliveryAreaToRemove, 1);

        this.props.updateDeliveryAreas(this.props.restaurant.id, newDeliveryAreas);
    }

    drawDeliveryZonesOnMap(zones, color) {
        this.setState({
            generatedDeliveryAreas: [...this.state.generatedDeliveryAreas, {
                color,
                zones
            }]
        });
    }

    clearDrawnDeliveryZonesFromMap() {
        this.setState({ generatedDeliveryAreas: [] });
    }

    numberOfDraftedDeliveryAreas() {
        return this.state.draftDeliveryAreas.length;
    }

    editDeliveryArea(tag) {
        const updatedStatus = { ...this.state.areasStatus };
        updatedStatus[tag] = updatedStatus[tag] || {};
        updatedStatus[tag].edit = true;

        this.setState({ areasStatus: updatedStatus });
    }

    updateDeliveryAreaEdit(areaTag, zoneIndex, polygon) {
        const updatedStatus = { ...this.state.areasStatus };
        updatedStatus[areaTag].zones = updatedStatus[areaTag].zones || {};
        updatedStatus[areaTag].zones[zoneIndex] = polygon;

        this.setState({ areasStatus: updatedStatus });
    }

    cancelDeliveryAreaEdit(tag) {
        const areaToCancel = this.props.restaurant.deliveryAreas.find(area => area.tag === tag);
        const updatedAreasStatus = { ...this.state.areasStatus };

        updatedAreasStatus[tag].edit = false;
        updatedAreasStatus[tag].zones = {};

        this.setState({ areasStatus: updatedAreasStatus });
    }

    saveDeliveryAreaEdit({ tag, estimatedTime, orderFee, minimumOrderPrice, companyMinimumOrderPrice }) {
        const deliveryAreasToSave = [...this.props.restaurant.deliveryAreas];
        const areaToSave = deliveryAreasToSave.find(area => area.tag === tag);

        areaToSave.zones = areaToSave.zones.map((zone, index) => {
            if (this.state.areasStatus[tag] && this.state.areasStatus[tag].zones && this.state.areasStatus[tag].zones[index]) {
                return { boundaries: this.getDeliveryAreaPolygonBoundaries(this.state.areasStatus[tag].zones[index]) };
            }
            return zone;
        });
        areaToSave.estimatedTime = parseFloat(estimatedTime);
        areaToSave.orderFee = parseFloat(orderFee);
        areaToSave.minimumOrderPrice = parseFloat(minimumOrderPrice);
        if (companyMinimumOrderPrice) areaToSave.companyMinimumOrderPrice = parseFloat(companyMinimumOrderPrice);

        const updatedAreasStatus = { ...this.state.areasStatus };
        updatedAreasStatus[tag].edit = false;
        updatedAreasStatus[tag].zones = {};

        this.props.updateDeliveryAreas(this.props.restaurant.id, deliveryAreasToSave);
        this.setState({ areasStatus: updatedAreasStatus });
    }

    render() {
        return (
            <Grid className='pi-delivery-grid'>
                <Grid.Row className='pi-delivery-grid-map-row'>
                    <Grid.Column>

                        <DeliveryMap
                            restaurant={this.props.restaurant}
                            areasStatus={this.state.areasStatus}
                            generatedDeliveryAreas={this.state.generatedDeliveryAreas}

                            addNewDraftDeliveryArea={this.addNewDraftDeliveryArea}
                            removeDraftDeliveryArea={this.removeDraftDeliveryArea}

                            updateDeliveryAreaEdit={this.updateDeliveryAreaEdit}

                        />

                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column>

                        <DeliveryNavigator
                            restaurant={this.props.restaurant}
                            areasStatus={this.state.areasStatus}

                            addNewDeliveryAreas={this.addNewDeliveryAreas}
                            removeDeliveryArea={this.removeDeliveryArea}

                            editDeliveryArea={this.editDeliveryArea}
                            saveDeliveryAreaEdit={this.saveDeliveryAreaEdit}
                            cancelDeliveryAreaEdit={this.cancelDeliveryAreaEdit}

                            numberOfDraftedDeliveryAreas={this.numberOfDraftedDeliveryAreas}

                            drawDeliveryZonesOnMap={this.drawDeliveryZonesOnMap}
                            clearDrawnDeliveryZonesFromMap={this.clearDrawnDeliveryZonesFromMap}

                        />

                    </Grid.Column>
                </Grid.Row>

            </Grid>
        );
    }
}

Delivery.propTypes = {
    restaurant: PropTypes.object,
    updateDeliveryAreas: PropTypes.func,

};

const mapStateToProps = (state, ownProps) => {
    const restaurant = state.businessApp.restaurants.find(rest => rest.id === ownProps.match.params.restId) || {};

    return { restaurant };
};

export default connect(mapStateToProps, { updateDeliveryAreas })(Delivery);
